<template>
  <div>js
    <v-card>
      <v-container>
        <v-row>
          <v-col cols="12">
            <v-card color="backgroundUnauthorizedExpired">
              <v-card-title class="text-h5"></v-card-title>
              <v-icon>mdi-thumb_up</v-icon>
              <table style="width:100%">
                <tbody>


                
                <tr class="rowone">
                  <td>
                    Row 1 color odd
                  </td>
                </tr>
                <tr class="rowone">
                  <td>
                    Row 1 color even
                  </td>
                </tr>
                <tr class="rowtwo">
                  <td>
                    Row 2 color even
                  </td>
                </tr>
                <tr class="rowthree">
                  <td>
                    Row 3 color odd
                  </td>
                </tr>

              </tbody>

              </table>
            </v-card>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-card color="backgroundUnauthorizedExpired2">
              <v-card-title class="text-h5"></v-card-title>
              <v-icon>mdi-thumb_up</v-icon>
              <table style="width:100%">


                <tbody>

                
                <tr class="rowone2">
                  <td>
                    Row 1 color odd
                  </td>
                </tr>
                <tr class="rowone2">
                  <td>
                    Row 1 color even
                  </td>
                </tr>
                <tr class="rowtwo2">
                  <td>
                    Row 2 color even
                  </td>
                </tr>
                <tr class="rowthree2">
                  <td>
                    Row 3 color odd
                  </td>
                </tr>

              </tbody>
              </table>
            </v-card>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-card color="backgroundUnauthorizedExpired3">
              <v-card-title class="text-h5"></v-card-title>
              <v-icon>mdi-thumb_up</v-icon>
               <table style="width:100%">
                <tbody>

                <tr class="rowone3">
                  <td>
                    Row 1 color odd
                  </td>
                </tr>
                <tr class="rowone3">
                  <td>
                    Row 1 color even
                  </td>
                </tr>
                <tr class="rowtwo3">
                  <td>
                    Row 2 color even
                  </td>
                </tr>
                <tr class="rowthree3">
                  <td>
                    Row 3 color odd
                  </td>
                </tr>
              </tbody>

              </table>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>
export default {
  name:'UnauthorizedColors',
  computed:{
    cssProps() {
      switch (this.$store.state.currentMoc.formColor) {
        case 'backgroundNormal': {
          return {
            '--firstRowEven': '#c8e3f8',
            '--firstRowOdd': '#EAF4FC',
            '--secondRowEven': '#bbdefb',
            '--thirdRowOdd': '#bbdefb',
            '--bgcolor': '#E3F2FD'
          }
        }
        case 'backgroundUnauthorizedExpired': {
          return {
            '--firstRowEven': '#F6E4E2',
            '--firstRowOdd': '#F1DFDD',
            '--secondRowEven': '#ECDAD8',
            '--thirdRowOdd': '#ECDAD8',
            '--bgcolor': '#FBE9E7'
          }
        }
        case 'backgroundUnauthorizedExpired2': {
          return {
            '--firstRowEven': '#FAE6E9',
            '--firstRowOdd': '#F5E1E4',
            '--secondRowEven': '#F0DCDF',
            '--thirdRowOdd': '#F0DCDF',
            '--bgcolor': '#FFEBEE'
          }
        }
        case 'backgroundUnauthorizedExpired3': {
          return {
            '--firstRowEven': '#E8E2F1',
            '--firstRowOdd': '#E3DDEC',
            '--secondRowEven': '#DED8E7',
            '--thirdRowOdd': '#DED8E7',
            '--bgcolor': '#F3E5F5'
          }
        }
        default:
          return {
            '--firstRowEven': '#c8e3f8',
            '--firstRowOdd': '#EAF4FC',
            '--secondRowEven': '#bbdefb',
            '--thirdRowOdd': '#bbdefb',
            '--bgcolor': '#E3F2FD'
          }
      }
    }
  }
}
</script>

<style scoped>

 /* '--firstRowEven': '#F6E4E2',
            '--firstRowOdd': '#F1DFDD',
            '--secondRowEven': '#ECDAD8',
            '--thirdRowOdd': '#ECDAD8',
            '--bgcolor': '#FBE9E7' */


.rowone:nth-of-type(odd) {
  background-color: #F6E4E2;
}

.rowone:nth-of-type(even) {
  background-color: #F1DFDD;
}
.rowtwo:nth-of-type(odd) {
  background-color: #ECDAD8;
}
.rowthree:nth-of-type(even) {
  background-color: #ECDAD8;
}

/* '--firstRowEven': '#FAE6E9',
            '--firstRowOdd': '#F5E1E4',
            '--secondRowEven': '#F0DCDF',
            '--thirdRowOdd': '#F0DCDF', */

.rowone2:nth-of-type(odd) {
  background-color: #FAE6E9;
}

.rowone2:nth-of-type(even) {
  background-color: #F5E1E4;
}
.rowtwo2:nth-of-type(odd) {
  background-color: #F0DCDF;
}
.rowthree2:nth-of-type(even) {
  background-color: #F0DCDF;
}

/* '--firstRowEven': '#E8E2F1',
            '--firstRowOdd': '#E3DDEC',
            '--secondRowEven': '#DED8E7',
            '--thirdRowOdd': '#DED8E7', */

.rowone3:nth-of-type(odd) {
  background-color: #E8E2F1;
}

.rowone3:nth-of-type(even) {
  background-color: #E3DDEC;
}
.rowtwo3:nth-of-type(odd) {
  background-color: #DED8E7;
}
.rowthree3:nth-of-type(even) {
  background-color: #DED8E7;
}


</style>
